const subjects = {
  BTech: [
    "CH 103-Chemistry",
    "MA 105-Calculus",
    "PH 105-Physics-I",
    "HS 159-English Language and Literature",
    "CS 103-Computer Programming",
    "CH 153-Chemistry Lab",
    "IC 151-Computer Programming Lab",
    "IC 153-Engineering Graphics",
    "MA 106-Linear Algebra and Ordinary Differential Equations I",
    "PH 106-Physics-II",
    "BSE 102-Bio-sciences",
    "HS 108-Fundamentals of Economics",
    "EE 104-Basic Electrical and Electronics Engineering",
    "ME 106-Basic Mechanical Engineering",
    "PH 156-Physics Lab",
    "EE 154-Basic Electrical and Electronics Engineering Lab",
    "IC 156-Basic Manufacturing Techniques",
    "ME 201-Solid Mechanics",
    "ME 203-Fluid Mechanics",
    "ME 257-Machine Drawing",
    "MM 205-Materials Science",
    "MM 207-Thermodynamics",
    "MM 203-Physical Metallurgy",
    "MM 201-Mechanics of Materials",
    "MA 203-Complex Analysis and Differential Equations-II ",
  ],
};

export { subjects };
